import React from "react";

export default function PlatformImage({ image }) {
  return (
    <div className="col-6 col-lg-3 mb-5 text-center">
      <img src={image} style={{maxWidth:"150px"}} alt="platform" className="w-100 img-fluid" />
    </div>
  );
}
